function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var fetch = require('node-fetch');

var objectPath = require("object-path");

module.exports = function Hypertopic(services) {
  var _this = this;

  this.getView = function (paths) {
    paths = paths instanceof Array ? paths : [paths];
    var uris = paths.map(function (p) {
      return encodeURI(p);
    }).map(function (p) {
      return services.map(function (s) {
        return s + p;
      });
    });
    uris = [].concat.apply([], uris);
    return Promise.all(uris.map(_get)).then(function (l) {
      return l.reduce(_concat, []);
    }).then(_index);
  };

  var _fetch = function _fetch(id, request, success) {
    return fetch(services[0] + '/' + id, request).then(function (x) {
      if (x.ok) {
        return x.json();
      }

      throw new Error(x.statusText);
    }).then(function (x) {
      return success(x);
    });
  };

  this.get = function (o) {
    return _fetch(o._id, {}, function (x) {
      return x;
    });
  };

  this.post = function (o) {
    return _fetch('', {
      method: 'POST',
      headers: headers({
        'Content-Type': 'application/json'
      }),
      credentials: 'include',
      body: JSON.stringify(o)
    }, function (x) {
      return Object.assign(o, {
        _id: x.id,
        _rev: x.rev
      });
    });
  };

  this["delete"] = function (o) {
    return _fetch(o._id, {
      method: 'DELETE',
      credentials: 'include',
      headers: headers({
        'If-Match': o._rev
      })
    }, function (x) {
      return {
        _id: x.id,
        _rev: x.rev
      };
    });
  };

  this.item = function (o) {
    return new Item(_this, _this.get(o)["catch"](function (x) {
      return {
        _id: o._id,
        item_corpus: o.item_corpus
      };
    }));
  };

  headers = function headers(additional) {
    return !_this.credentials ? additional : Object.assign({}, additional, {
      'Authorization': 'Basic ' + Buffer.from("".concat(_this.credentials.name, ":").concat(_this.credentials.password)).toString('base64')
    });
  };

  this.auth = function (name, password) {
    _this.credentials = {
      name: name,
      password: password
    };
    return _this;
  };

  function Item(db, item) {
    this.setAttributes = function (attributes) {
      return item.then(function (o) {
        return Object.assign(o, attributes);
      }).then(db.post);
    };

    this.unsetAttribute = function (key) {
      return item.then(function (o) {
        delete o[key];
        return o;
      }).then(db.post);
    };

    this.setTopic = function (topic, viewpoint) {
      return item.then(function (o) {
        o.topics = o.topics || {};
        o.topics[topic] = {
          viewpoint: viewpoint
        };
        return o;
      }).then(db.post);
    };

    this.unsetTopic = function (topic_id) {
      return item.then(function (o) {
        if (o.topics) delete o.topics[topic_id];
        return o;
      }).then(db.post);
    };

    this.then = function (x) {
      return item.then(x);
    };

    return this;
  }

  return this;
};

var _get = function _get(uri) {
  return fetch(uri).then(function (x) {
    return x.json();
  })["catch"](function (_) {
    return {
      rows: []
    };
  });
};

var _concat = function _concat(l, x) {
  return l.concat(x.rows);
};

var _ensureExists = function _ensureExists(data, path, value) {
  return objectPath.ensureExists(data, path, value) || value;
};

var _assign = function _assign(data, row) {
  var source = row.value;

  switch (_typeof(source)) {
    case 'number':
      {
        var target = _ensureExists(data, row.key, []);

        target.push(source);
        break;
      }

    case 'object':
      {
        var _target = _ensureExists(data, row.key, {});

        for (var k in source) {
          if (k[0] !== '_') {
            if (!_target[k]) {
              _target[k] = [];
            }

            var values = source[k];
            values = Array.isArray(values) ? values : [values];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var v = _step.value;
                if (['Sans nom', '', ' '].includes(v) || _target[k].includes(v)) continue;

                _target[k].push(v);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
        }

        break;
      }

    default:
      console.error("Type ".concat(_typeof(source), " not handled!"));
  }
};

var _index = function _index(rows) {
  var data = {};
  rows.forEach(function (r) {
    _assign(data, r);
  });
  return data;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/hypertopic/lib/index.js
// module id = 13
// module chunks = 0